'use client';

import '/public/static/globals.scss';

import {useEffect, useState} from 'react';

import EventHelmet from '@/constants/common/event-page/event-helmet';

import {Route, BrowserRouter as Router, Routes} from 'react-router-dom';

import {
  AutopayBenefit,
  NewSubscribe,
  SoopiDailyMission,
  SoopiConversation,
  SubscribePlus,
  SubscribeDirectChange,
  MarketingConsent,
  FreecshotPlus,
  SavygEventApply,
  SavygEventAward,
} from './events';
import {SoopUiToast, SoopUiDialog} from '@/components/ui';
import Bridge from '@/app/(events)/events/bridge/index/page';
import GiftSubEvent from '@/app/(events)/events/giftsub_event/index/page';
const RootLayout = () => {
  const [bodyId, setBodyId] = useState('');

  const [render, setRender] = useState(false);

  useEffect(() => {
    if (bodyId !== '') {
      setRender(true);
    }
  }, [bodyId]);

  // Note. 아래 if문 개발 모드에선 주석 처리 필요
  if (typeof window === 'undefined') {
    return null;
  }

  return (
    <html lang='ko'>
      {/*TODO 기능 스크립트 로드나, meta 데이터 관련된 부분은 EventHelmet에 넣어주세요*/}

      <EventHelmet />

      <body id={bodyId}>
        <Router>
          <Routes>
            <Route
              path='/events/new-subscribe' // 구독 개편 이벤트
              element={<NewSubscribe onBodyId={setBodyId} />}
            />

            <Route
              path='/events/autopay-benefit' // 자동결제 이벤트
              element={<AutopayBenefit onBodyId={setBodyId} />}
            />

            <Route
              path='/events/soopi/daily-mission' // soopi 데일리 미션
              element={<SoopiDailyMission onBodyId={setBodyId} />}
            />

            <Route
              path='/events/soopi/conversation' // soopi 대화하기
              element={<SoopiConversation onBodyId={setBodyId} />}
            />

            <Route
              path='/events/subs_plus' // 구독 고도화 프로모션
              element={<SubscribePlus onBodyId={setBodyId} />}
            />

            <Route
              path='/events/giftsub_event' // 숲트리머 구독 선물권 이벤트
              element={<GiftSubEvent onBodyId={setBodyId} />}
            />
            <Route path={'/events/bridge'} element={<Bridge />} />

            <Route
              path='/events/marketing-consent' // 마케팅 수신 동의 2차 프로모션
              element={<MarketingConsent onBodyId={setBodyId} />}
            />

            <Route
              path='/events/subs-direct-change' // 구독 플러스 즉시 변경 이벤트
              element={<SubscribeDirectChange onBodyId={setBodyId} />}
            />

            <Route
              path='/events/freecshot-plus' // 프릭샷 플러스 이벤트
              element={<FreecshotPlus onBodyId={setBodyId} />}
            />

            <Route
              path='/events/savyg-event/apply' // SAVYG 2차 오픈 이벤트
              element={<SavygEventApply onBodyId={setBodyId} />}
            />

            <Route
              path='/events/savyg-event/award' // SAVYG 수상자 이벤트
              element={<SavygEventAward onBodyId={setBodyId} />}
            />
          </Routes>
        </Router>
        <div style={{width: '100vw'}}>
          <SoopUiToast />
        </div>
        <SoopUiDialog />
      </body>
    </html>
  );
};

export default RootLayout;
